import { render } from "./Rate.vue?vue&type=template&id=73f9c998&scoped=true&bindings={\"level\":\"props\"}"
import script from "./Rate.vue?vue&type=script&lang=ts"
export * from "./Rate.vue?vue&type=script&lang=ts"

import "./Rate.vue?vue&type=style&index=0&id=73f9c998&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73f9c998"

export default script